// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"40bc109c","732":"c027258d","977":"43756a27"}[chunkId] + ".chunk.js";
};